export default __webpack_public_path__ + "static/media/tools_black.5ea3a400.svg";